/* eslint-disable */
import React from 'react'
import {message} from 'antd'
import http from '../../Component/Interceptor/Interseptor'
import {Link} from 'react-router-dom'
import cookie from 'react-cookies'
import ORDER_STATUS from '../BaseComponent/ORDERSTATUS'

class AddOrderStatus extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      error: ''
    }
  }
  componentDidMount() {}

  addOrderStatus() {
    var orderStatusName = document.getElementById('name').value
    var enabled = document.getElementById('enabled').value
    var color = document.getElementById('color').value
    var sortOrder = document.getElementById('sortOrder').value
    var nameError = false
    var colorError = false
    var enableError = false
    var sortOrderError = false
    var formError = false
    if (orderStatusName == '') {
      formError = true
      nameError = true
      message.error('نام وضعیت وارد شود')
    } else {
      if (!nameError) {
        this.setState({
          error: ''
        })
      }
    }

    if (enabled == '') {
      formError = true
      enableError = true
      message.error('وضعیت را مشخص کنید')
    } else {
      if (!enableError) {
        this.setState({
          error: ''
        })
      }
    }

    if (color == '') {
      formError = true
      colorError = true
      message.error('رنگ را مشخص کنید')
    } else {
      if (!colorError) {
        this.setState({
          error: ''
        })
      }
    }

    if (sortOrder !== '' && sortOrder.match(/[a-z A-Z آ-ی]/g)) {
      formError = true
      sortOrderError = true
      message.error('ترتیب نمایش باید عددی باشد')
    } else {
      if (!sortOrderError) {
        this.setState({
          error: ''
        })
      }
    }
    if (!formError) {
      let data = {
        orderStatusName,
        enabled,
        color,
        sortOrder: sortOrder === '' ? undefined : sortOrder
      }

      http
        .post(`${ORDER_STATUS.ORDERS_STATUS_ORDERSTATUS_ADD}`, data)
        .then((response) => {
          if (response.data.error == null) {
            message.success('وضعیت جدید اضافه شد')
            setInterval(() => {
              window.location.assign('/base/orderStatus/reportOrderStatus')
            }, 2000)
          } else {
            message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
          }
        })
        .catch((error) => {
          alert(JSON.stringify(error))
        })
    }
  }

  submit(e) {
    e.preventDefault()
  }
  render() {
    return (
      <div className={'rtl'}>
        {/*<AdminMenu/>*/}
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>اطلاعات پایه</li>
            <li>وضعیت سفارشات</li>
            <li>
              <Link to={'/base/orderStatus/reportOrderStatus'}>لیست وضعیت ها</Link>
            </li>
            <li>افزودن وضعیت</li>
          </ul>
          <form className="verticalForm" onSubmit={this.submit.bind(this)}>
            <div className="headerVertical">
              <p>ثبت وضعیت</p>
            </div>
            <div className="formComponent">
              <label>
                عنوان <span className="requireFiled">*</span>
              </label>
              <input type="text" id="name" className="form-control" />

              <label>
                رنگ <span className="requireFiled">*</span>
              </label>
              <input type="color" id="color" className="form-control" />

              <label>
                وضعیت فعال <span className="requireFiled">*</span>
              </label>
              <select className="form-control" name="enabled" id="enabled">
                <option value="">------</option>
                <option value={1}>فعال</option>
                <option value={0}>غیر فعال</option>
              </select>

              <label>ترتیب نمایش </label>
              <input type="text" id="sortOrder" className="form-control" />

              <button className="btn btn-info btn-block" onClick={this.addOrderStatus.bind(this)}>
                ثبت وضعیت
              </button>
            </div>
          </form>
        </div>
      </div>
    )
  }
}

export default AddOrderStatus
